module.exports = __webpack_public_path__ + "img/ep-O.208602dd.jpg";